import { render, staticRenderFns } from "./jak-dzialaja-obligacyjne-fundusze-etf.md?vue&type=template&id=17fe8196&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports